import React from "react";
import EAAvailabilityDots from "../../shared/AvailabilityDots/EAAvailabilityDots";
import { format } from "date-fns";
import { Tooltip } from "@mui/material";
import { ExerciseForHourlySchedule } from "../../../models/ExerciseForHourlySchedule";

interface IProps {
  data: { [name: string]: ExerciseForHourlySchedule[] };
  getPercentageFree: (capacity: number, reserved: number) => number;
}

const HourlyScheduleDesktopTable: React.FC<IProps> = ({ data, getPercentageFree }) => {
  return (
    <table className="hourly-schedule-table">
      <tbody>
        {Object.keys(data).map((item, index) => (
          <tr key={index}>
            <td className="bold">{item}</td>
            {Object.values(data[item]).map((itemValue, itemIndex) => (
              <td key={itemIndex}>
                <Tooltip
                  title={
                    <span className="hourly-schedule-table-tooltip">
                      Wolne miejsca: {itemValue.capacity - itemValue.reserved} z {itemValue.capacity}
                    </span>
                  }
                >
                  <div className={`hourly-schedule-table-item`}>
                    {format(itemValue.startTime, "HH:mm")}
                    <EAAvailabilityDots
                      percentageFree={getPercentageFree(itemValue.capacity, itemValue.reserved)}
                      labelled={false}
                    />
                  </div>
                </Tooltip>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default HourlyScheduleDesktopTable;
